import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  MANAGE_SUBS_RESET_GROUPS_AUDIT_TRAIL_DATA,
} from './constants';

export function resetGroupsAuditTrailData() {
  return {
    type: MANAGE_SUBS_RESET_GROUPS_AUDIT_TRAIL_DATA,
  };
}

export function useResetGroupsAuditTrailData() {
  const dispatch = useDispatch();
  const boundAction = useCallback((...params) => dispatch(resetGroupsAuditTrailData(...params)), [dispatch]);
  return { resetGroupsAuditTrailData: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_RESET_GROUPS_AUDIT_TRAIL_DATA:
      return {
        ...state,
        createGroupsEvents: null,
      };

    default:
      return state;
  }
}
